import {Col, Row, Form, Button, Modal, Alert} from "react-bootstrap";
import React, {useState} from "react";
import Back from "../layout/template/back";
import Password from "../form/passwordForm";
import {Link, useLocation, useNavigate} from "react-router-dom";
import StorageManager from "../../services/StorageManager.service";
import AppRoute from "../../utils/AppRoute";
import ApiService from "../../services/ApiService";
import ErrorLogin from "../modal/errorLogin";
import ErrorServer from "../modal/errorServer"
import eventBus from "../../utils/EventBus";
import GenericErrorModal from "../modal/genericErrorModal";


const Login = () => {

    const location = useLocation()
    const navigate = useNavigate()
    const [userEmail, setUserEmail] = useState()
    const [userPassword, setUserPassword] = useState()
    const [showLoginErrorAlert, setShowLoginErrorAlert] = useState(false)
    const [showLoginMailSent, setShowLoginMailSent] = useState(false)
    const [showErrorServer, setShowErrorServer] = useState(false)
    const [serverErrorText, setServerErrorText] = useState("")
    const [errorModal, setErrorModal] = useState({
        state: false,
        title: "",
        body: ""
    });

    const handleOnSubmit = (event) => {
        event.preventDefault();

        ApiService.login(userEmail, userPassword).then((result) => {
            console.log(result)
            if (result === 200) {
                ApiService.getUserInfoFromId().then((userData) => {
                    let userString = userData.firstName[0]
                    userString += userData.lastName[0]
                    eventBus.dispatch("userLogin", {activeUser: userString})
                    StorageManager.storeActiveUser(userString)
                })

                ApiService.getBasketData().then(activeBasket => {
                    const redirectTo = location.state?.from
                    redirectTo == null ? navigate(AppRoute.BASE) : navigate(redirectTo)
                })
            } else if(result === 302){
                setShowLoginErrorAlert(true)
            } else if(result === 500){
                setServerErrorText("Errore interno del server, riprovare tra poco")
                setShowErrorServer(true)
            }
        })
    }
    const handleRequestNewPassword = (e) => {
        e.preventDefault();

        if(userEmail === "" || userEmail === undefined || userEmail === null){
            setErrorModal({
                state: true,
                title: "Inserire la propria email sul campo Email",
                body: "Continua"
            })
        } else {
            ApiService.resetPassword(userEmail).then(response => {
                if(response.ok){
                    setShowLoginErrorAlert(false)
                    setShowLoginMailSent(true)
                } else {
                    setErrorModal({
                        state: true,
                        title: "Errore nel recupero",
                        body: "Continua"
                    })
                }
            })
        }
    }

    const handleCloseErrorModal = () => setErrorModal({
        state: false,
        title: "",
        body: ""
    })
    const handleCloseLoginError = () => setShowLoginErrorAlert(false)
    const handleCloseEmailSent = () => setShowLoginMailSent(false)
    const hanldeCloseServerError = () => setShowErrorServer(false)

    return (
        <>
            <Row>
                <Col lg={6}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Effettua Login</h2>
                            <Alert variant={'primary'}>
                                <Alert.Heading className={'fw-bold fs-5'}>Nuovo shop - Nuovo account:</Alert.Heading>
                                Dal 01.08.2023 è attivo un
                                nuovo shop ed il login dello shop precedente non è più valido. Si è pregati di creare un
                                nuovo profilo.
                            </Alert>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form>
                                <Form.Group className="mb-3" controlId="mail">
                                    <Form.Label>E-mail*</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Scrivi qui..."
                                        onChange={(value) => setUserEmail(value.target.value)}
                                    />
                                </Form.Group>

                                <Password
                                    label={'Password'}
                                    event={setUserPassword}
                                />

                                <Button variant={'link'} className="nextButton"
                                        onClick={(e) => handleRequestNewPassword(e)}>
                                    Password dimenticata
                                </Button>

                                <Modal show={showLoginMailSent} onHide={handleCloseEmailSent} backdrop='static'
                                       keyboard="False" size="lg"
                                       centered>
                                    <Modal.Header className={'justify-content-end py-0'}>
                                        <Button variant={'link'} onClick={handleCloseEmailSent}>
                                            chiudi x
                                        </Button>
                                    </Modal.Header>
                                    <Modal.Body className={'mt-4 mb-5'}>
                                        <h2 className={'title fw-bold'}>Reimposta password</h2>
                                        <p>Abbiamo inviato al tuo indirizzo e-mail {userEmail} un link per reimpostare
                                            la tua password.</p>
                                    </Modal.Body>
                                </Modal>

                                <div className={'w-100 d-flex justify-content-end'}>
                                    <Button
                                        variant={'primary'}
                                        type={'submit'}
                                        className={'px-5 fw-bold'}
                                        onClick={(e) => handleOnSubmit(e)}
                                    >Accedi</Button>
                                </div>
                            </Form>
                        </Col>
                    </Row>

                    <ErrorLogin handlePasswordDimenticata={handleRequestNewPassword} handleClose={handleCloseLoginError}
                                showModal={showLoginErrorAlert}/>

                    <ErrorServer handleClose={hanldeCloseServerError} showModal={showErrorServer} bodyText={serverErrorText}/>
                    <GenericErrorModal handleClose={handleCloseErrorModal} contentText={errorModal} showModal={errorModal.state}/>


                    <Row className={'my-5'}>
                        <Col>
                            <h2 className={'fw-bold'}>Non hai ancora un’account?</h2>
                            <Link to={AppRoute.REGISTRATION} className={'px-0'}><i className={"icon arrow me-1"}/>Crea
                                nuovo account</Link>
                        </Col>
                    </Row>

                </Col>
            </Row>
        </>

    );
}

export default Login;
